export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError("needs to be wrapped around a product's <form> element")
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    const sectionsToRequest = (() => {
      if (window.BAO.utils.getElement('push-cart')) {
        return window.BAO.sectionRenderer.pushCartSections
      }

      if (window.BAO.utils.getElement('cart-items')) {
        return window.BAO.sectionRenderer.cartSections
      }

      return []
    })()

    return window.BAO.Cart.addItemFromForm(this.form, {
      sections: sectionsToRequest.map(s => s.section),
    })
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
